export const parseDiscountConfig = config => {
  if (!config) return "";

  return config.type?.toLowerCase() === "percentage" ? `${config.value}%` : config.value;
};
